import { createContext } from 'preact';
import type {
  WidgetAnalyticsEvent,
  WidgetAnalyticsEventName,
  WidgetAnalyticsRuntimeMetadata,
} from './types';

export interface WidgetAnalyticsContextValue {
  metadata: WidgetAnalyticsRuntimeMetadata | null;
  track: <TName extends WidgetAnalyticsEventName>(
    event: WidgetAnalyticsEvent<TName>,
  ) => void;
}

/** Context that provides access to analytics tracking */
export const AnalyticsContext = createContext<WidgetAnalyticsContextValue>({
  metadata: null,
  track: () => undefined,
});
